module.exports = __webpack_public_path__ + "img/mt4-icon6.355e742.png";